// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import FupUserPagingResultModel from '../../model/fup-user-paging-result-model';
import FupUserPagingResultDTO from '../dto/fup-user-paging-result-dto';
import dtoSchema from '../schemas/fup-user-paging-result-schema';
import FupUserModel from '../../model/fup-user-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class FupUserPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<FupUserPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => FupUserModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: FupUserModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<FupUserPagingResultDTO>): FupUserPagingResultModel;
  static toModel(dto: DeepPartial<FupUserPagingResultDTO> | undefined | null): FupUserPagingResultModel | undefined;
  static toModel(dto: DeepPartial<FupUserPagingResultDTO> | undefined | null): FupUserPagingResultModel | undefined {
    return dto ? new FupUserPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<FupUserPagingResultModel> | FupUserPagingResultModel): FupUserPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as FupUserPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for FupUserPagingResultModel, can not map to FupUserPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
